module.exports = __webpack_public_path__ + "3c94b2a9c8e31f940944cd267331a2f2.png";